var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalLicenses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.29688 9.67969H13.8279V10.6015H8.29688V9.67969ZM8.29688 11.9843H13.8279V12.9061H8.29688V11.9843Z",
    fill: "#40499D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5151 6.64387L16.8634 5.99213L15.3193 7.53622C15.0988 7.2704 14.8541 7.02567 14.5883 6.8052L16.1324 5.26112L15.4806 4.60938L13.8167 6.2733C12.764 5.66517 11.54 5.42148 10.3346 5.58003C9.12921 5.73858 8.00985 6.2905 7.15018 7.15018C6.2905 8.00985 5.73858 9.12921 5.58003 10.3346C5.42148 11.54 5.66517 12.764 6.2733 13.8167L4.60938 15.4806L5.26112 16.1324L6.8052 14.5883C7.02567 14.8541 7.2704 15.0988 7.53622 15.3193L5.99213 16.8634L6.64388 17.5151L8.3078 15.8512C9.36053 16.4593 10.5845 16.703 11.7899 16.5445C12.9953 16.3859 14.1147 15.834 14.9743 14.9743C15.834 14.1147 16.3859 12.9953 16.5445 11.7899C16.703 10.5845 16.4593 9.36053 15.8512 8.3078L17.5151 6.64387ZM11.0623 15.6714C10.1506 15.6714 9.2595 15.4011 8.50152 14.8947C7.74354 14.3882 7.15277 13.6683 6.80391 12.8261C6.45505 11.9839 6.36377 11.0571 6.54162 10.163C6.71947 9.26895 7.15845 8.44766 7.80306 7.80306C8.44767 7.15845 9.26895 6.71947 10.163 6.54162C11.0571 6.36377 11.9839 6.45505 12.8261 6.80391C13.6683 7.15277 14.3882 7.74354 14.8947 8.50152C15.4011 9.2595 15.6715 10.1506 15.6715 11.0623C15.6701 12.2843 15.1841 13.4559 14.32 14.32C13.4559 15.1841 12.2843 15.6701 11.0623 15.6714Z",
    fill: "#40499D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalLicenses);
export default __webpack_public_path__ + "static/media/TotalLicenses.43bc4d6901d3d479cf366c2cb1b35a39.svg";
export { ForwardRef as ReactComponent };